define('BtnSwitchView',[
    'backbone',
    'jquery',
    'template!blocks/ui/switch',
    'template!blocks/ui/toggle'
    ], function (
        Backbone,
        $
    ) {

    var YES = 'yes',
        NO = 'no';

    var BtnSwitchView = Backbone.View.extend({
        events: {
            'click button': 'onClick',
            'tap button': 'onClick',
            'change input': 'onInputChange'
        },
        initialize: function(options){
            var view = this,
                type = 'switch',
                input = view.$('input'),
                value = options.value; //

            if(view.$el.is('.btn-switch-toggle')){
                type = 'toggle';
            }
            view.type = type;
            //
            //
            //
            if(options.checked === true){
                value = YES;
            }else if(options.checked === false){
                value = NO;
            }

            var disabled = options.disabled || view.$('input').is(':disabled');
            if(disabled){
                view.setDisabled(disabled);
            }

            if(input.length){
                switch(input.attr('type')){
                    case 'checkbox':
                        // checkbox
                        value = value || (input.is(':checked') ? YES:NO);
                        break;
                }
            }
            if(!value){
                if(options.value){
                    value = options.value;
                }else if(view.$('button.active').length){
                    // utilise le DOM et le data-attribute value pour obtenir la valeur
                    value = view.$('button.active').data('value');
                }else if(view.$el.is('.checked')){
                    // ou bien la class checked
                    value = YES;
                }else{
                    // par default la valeur est NO
                    value = NO;
                }
            }
            view.setValue(value);

            view.$el.data('BtnSwitchView',view);
        },
        onClick: function(e){
            var view = this,dataValue;
            e.preventDefault();
            if(!view.$el.is('.disabled')){
                if(view.type === 'toggle'){
                    view.toggle();
                    return;
                }else{
                    dataValue = $(e.currentTarget).data('value');
                }
                view.setValue(dataValue);
            }
        },
        onInputChange:function(e){
            var view = this,
                input = view.$('input'),
                value = view.getValue() === YES,
                checked = input.is(':checked');
            if(value!=checked){
                // si la valeur n'est pas la même que le checkbox, on execute le setValue
                view.setValue(checked?YES:NO);
            }
        },
        setValue:function(value,silent){
            var view = this,
                fromValue = view.value,
                input = view.$('input');
            if(value==undefined){
            }
            view.value = value;
            view.update();
            //
            if(fromValue && fromValue !== value){
                if(!silent){
                    view.trigger('change', value);
                    input.trigger('change', value);
                }
            }
        },
        setDisabled:function(disabled){
            this.$el.toggleClass('disabled',disabled);
        },
        getValue:function(){
            return this.value;
        },
        toggle:function(test,silent){
            var view = this, value = view.value;
            if(test === true){
                value = YES;
            }else if(test === false){
                value = NO;
            }else{
                value = value === YES ? NO : YES;
            }
            view.setValue(value,silent);
        },
        check:function(test,silent){
            // alias for setValue(boolean => 'YES':'NO')
            var value = test==true ? YES : NO;
            if(test===true){
                value = YES;
            }else if(test===false){
                value = NO;
            }
            this.setValue(value,silent);
            //this.updateBtn(this.$('button:eq('+index+')'));
        },
        update: function () {
            //
            var view = this,
                newValue = view.value,
                input = view.$('input'),
                button = view.$('button[data-value="'+newValue+'"]');
            if(button.length) {
                button.addClass('active').siblings().removeClass('active');
                //
                function ApplyDimensions($el) {
                    var width = Math.max($el.outerWidth() + 3),
                        left = Math.ceil($el.position().left) -1;
                    // ceil func prevent bug onton unvisible el
                    view.$('span').css({width: width, left: left});
                }

                if (button.not(':visible')) {
                    // si l'element est caché, on essaie de le sortir pour mesurer ses dimensions
                    var clone = view.$el.clone();
                    clone.appendTo('body');
                    ApplyDimensions(clone.find('.active'));
                    clone.remove();
                } else {
                    ApplyDimensions(button);
                }
            }
            if (input.length) {
                input.prop('checked', newValue === YES);
            }
            view.$el.toggleClass('checked',newValue == YES);
        },
        remove:function(){
            Backbone.View.prototype.remove.apply(this);
        }
    });

    BtnSwitchView.initializeBtnSwitchOfView = function(view){
        var buttons = BtnSwitchView.initializeBtnSwitch(view.$('.btn-switch'));
        view.attachViews(buttons);
        return buttons;
    };

    BtnSwitchView.initializeBtnSwitchOfEl = function(el){
        return BtnSwitchView.initializeBtnSwitch($('.btn-switch', el));
    };

    BtnSwitchView.initializeBtnSwitch = function(jqueryContext){
        var buttons = [];
        jqueryContext.each(function(){
            var $el = $(this), btnSwitchView = $el.data('BtnSwitchView');
            if(!btnSwitchView){
                var button = new BtnSwitchView({el:this});
                buttons.push(button);
            }
        });
        return buttons;
    };
    
    return BtnSwitchView;
});
